import React from 'react';

type Props = {
    children: React.ReactNode;
};

const headerHeight = 40;
const footerHeight = 30;

const CustomLayout = ({ children }: Props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Header */}
            <header style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: `${headerHeight}px`,
                backgroundColor: '#001529',
                color: '#fff',
                padding: '10px 20px',
                fontSize: '18px',
                fontWeight: 'bold',
                zIndex: 1000,
            }}>
                Victum ITS
            </header>

            {/* Contenido principal */}
            <main style={{ flex: 1, padding: '20px', backgroundColor: '#f0f2f5', marginTop: `${headerHeight}px`, marginBottom: `${footerHeight}px` }}>
                {children}
            </main>

            {/* Footer */}
            <footer style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: `${footerHeight}px`,
                backgroundColor: '#001529',
                color: '#fff',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                zIndex: 1000,
            }}>
                © {new Date().getFullYear()} Grupo CTI. Todos los derechos reservados.
            </footer>
        </div>
    );
};

export default CustomLayout;
